import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getInitialLaunchPageConfigs, getInitialLaunchPageToShow } from '../../lib/postLoginPrompts';
import useLoginStatusStore from '../../zustandStore/loginStatusStore';
import { isPushNotificationAvailable, isWebApp } from '../../lib/utils';
import useAsyncAction from '../../commonComponents/Hooks';
import { isPushNotificationGranted } from './pushNotification/pushNotification';

const PostLoginPromptHandler = (): null => {
	const navigate = useNavigate();
	const location = useLocation();
	const loggedIn = useLoginStatusStore((state) => state.loggedIn);

	const performAsyncAction = useAsyncAction();

	useEffect(() => {
		const handleFirstLaunch = async () => {
			// Only check for initial launch if user is logged in
			if (!loggedIn) {
				return;
			}

			let canShowSetupPushNotificationPrompt = false;
			if (!isWebApp && isPushNotificationAvailable) {
				const isGranted = await isPushNotificationGranted();
				if (!isGranted) {
					canShowSetupPushNotificationPrompt = true;
				}
			}

			// Check if we're already on one of the initial launch pages
			const pageConfigs = getInitialLaunchPageConfigs();
			const initialLaunchPageUrls = pageConfigs.map((pageConfig) => pageConfig.url);
			const isOnInitialLaunchPage = initialLaunchPageUrls.includes(location.pathname);

			// If we're already on an initial launch page, don't navigate anywhere
			if (isOnInitialLaunchPage) {
				return;
			}

			try {
				const pageToShow = await getInitialLaunchPageToShow(canShowSetupPushNotificationPrompt);
				if (pageToShow) {
					navigate(pageToShow, { replace: true });
				}
			} catch {
				// Silent error handling for initial launch check
			}
		};

		performAsyncAction(async () => {
			await handleFirstLaunch();
		});
	}, [loggedIn]);

	return null; // This component doesn't render anything
};

export default PostLoginPromptHandler;
